__turbopack_context__.v({
  "issuerLink": "issuers-module-scss-module__sSXX9G__issuerLink",
  "issuersContainer": "issuers-module-scss-module__sSXX9G__issuersContainer",
  "link": "issuers-module-scss-module__sSXX9G__link",
});
